import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { bairroUrl } from "@/data/site";

export const BairroCard = ({ bairro }) => {
  return (
    <Link
      to={bairroUrl(bairro.slug)}
      className="group flex items-center gap-3 bg-white rounded-lg border border-gray-100 px-4 py-3.5 hover:border-brand-red hover:shadow-md transition-all"
      data-testid={`bairro-card-${bairro.slug}`}
    >
      <span className="grid place-items-center w-9 h-9 rounded-md bg-brand-light group-hover:bg-brand-red transition-colors">
        <MapPin className="w-4 h-4 text-brand-red group-hover:text-white transition-colors" />
      </span>
      <span className="min-w-0">
        <span className="block font-semibold text-sm text-brand-black truncate">{bairro.name}</span>
        <span className="block text-xs text-gray-500">{bairro.region}</span>
      </span>
    </Link>
  );
};
